// The `/debug` tab set and its `?tab=` parser — kept out of DebugScreen.tsx so the router can import them
// without breaking fast refresh (the settingsTabs.ts shape).
import type { TabDef } from "@cntrl/ui";

export type DebugTab = "connect" | "sync" | "socials" | "songstats" | "push";

export const DEBUG_TABS: readonly TabDef<DebugTab>[] = [
  { key: "connect", label: "Connect" },
  { key: "sync", label: "Sync" },
  { key: "socials", label: "Socials" },
  { key: "songstats", label: "Songstats" },
  { key: "push", label: "Push" },
];

/** A `?tab=` value, or the first tab for anything unrecognised. */
export function parseDebugTab(value: unknown): DebugTab {
  return DEBUG_TABS.some((t) => t.key === value) ? (value as DebugTab) : "connect";
}
